import { AlertCircle } from "lucide-react";

import { AdminEmptyState } from "@/components/admin/AdminSurface";
import { Button } from "@/components/ui/button";

interface AdminReviewEmptyProps {
  searchTerm: string;
  statusFilter: "all" | "pending" | "approved" | "rejected" | "unassigned";
  setSearchTerm: (value: string) => void;
  setStatusFilter: (value: "all" | "pending" | "approved" | "rejected" | "unassigned") => void;
}

const AdminReviewEmpty = ({
  searchTerm,
  statusFilter,
  setSearchTerm,
  setStatusFilter,
}: AdminReviewEmptyProps) => {
  const description = searchTerm
    ? `No listings match "${searchTerm}". Try a broader search or return to the default pending queue.`
    : statusFilter === "pending"
      ? "There are no pending listings to review right now."
      : statusFilter === "approved"
        ? "There are no approved listings in the current result set."
        : statusFilter === "rejected"
          ? "There are no rejected listings in the current result set."
          : statusFilter === "unassigned"
            ? "Every listing currently has an assigned owner."
            : "There are no listings in the moderation queue yet.";

  return (
    <AdminEmptyState
      icon={AlertCircle}
      title={searchTerm ? "No matching listings" : "Nothing in this queue"}
      description={description}
      action={
        <Button
          type="button"
          variant="outline"
          className="rounded-lg border-gray-200 text-gray-700 hover:border-whatsapp hover:text-whatsapp"
          onClick={() => {
            setSearchTerm("");
            setStatusFilter("pending");
          }}
        >
          Return to pending listings
        </Button>
      }
    />
  );
};

export default AdminReviewEmpty;
